import * as angular from "angular";
import {IQService} from "angular";
import {RuleEngineRequestsService} from "./rule-engine-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class RuleEngineService {

  constructor(private bringozLoaderService: BringozLoaderService, private $q: IQService, private ruleEngineRequestsService: RuleEngineRequestsService) {
  }

  getEntityActions(entity: string) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.ruleEngineRequestsService.getEntityActions(entity)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  getEntityFilters(entity: string) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.ruleEngineRequestsService.getEntityFilters(entity)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

  getEntitySubtypes(entity: string) {
    this.bringozLoaderService.on();
    const deferred = this.$q.defer();

    this.ruleEngineRequestsService.getEntitySubtypes(entity)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise
  }

}

angular
  .module('bringoz.admin.ruleEngine')
  .service('ruleEngineService', RuleEngineService);
